'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
require('tslib');

/**
 * @public
 */
var MotionConfigContext = React.createContext({
  transformPagePoint: function (p) {
    return p;
  },
  features: [],
  isStatic: false
});

exports.MotionConfigContext = MotionConfigContext;
